import React from "react";
import { withStyles } from "@material-ui/core/styles";
import MaterialButton from "@material-ui/core/Button";
import MaterialIconButton from "@material-ui/core/IconButton";
import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrashAlt, faEllipsisV } from "@fortawesome/free-solid-svg-icons";

/**
 * @params options : [{text,icon,onClick}]
 */
export default ({
  isIconButton,
  text,
  borderRadius,
  color,
  icon,
  options,
  optionBackground,
}) => {
  const [anchorEl, setAnchorEl] = React.useState(null);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const StyledMenuItem = withStyles((theme) => ({
    root: {
      "&:focus": {
        backgroundColor: optionBackground || `red`,
        "& .MuiListItemIcon-root, & .MuiListItemText-primary": {
          color: theme.palette.common.white,
        },
      },
    },
  }))(MenuItem);

  const TriggerButton = isIconButton ? (
    <MaterialIconButton
      aria-controls="customized-menu"
      aria-haspopup="true"
      onClick={handleClick}
    >
      <FontAwesomeIcon
        style={{ fontSize: "16px", color: color || `#fff` }}
        icon={icon}
      />
    </MaterialIconButton>
  ) : (
    <MaterialButton
      style={{
        borderRadius: borderRadius || 0,
        color: color || "#fff",
        borderColor: color || "#fff",
      }}
      aria-controls="customized-menu"
      aria-haspopup="true"
      variant="outlined"
      onClick={handleClick}
    >
      {icon && (
        <FontAwesomeIcon
          style={{ fontSize: "16px", color: color || `#fff` }}
          icon={faEllipsisV}
        />
      )}
      {!icon && text}
    </MaterialButton>
  );

  return (
    <div>
      {TriggerButton}
      <Menu
        elevation={0}
        getContentAnchorEl={null}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "center",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "center",
        }}
        id="customized-menu"
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleClose}
      >
        {options.map(({ icon, onClick, text }) => {
          return (
            <StyledMenuItem
              onClick={() => {
                onClick();
                handleClose();
              }}
            >
              {icon && (
                <ListItemIcon>
                  <FontAwesomeIcon icon={icon} />
                </ListItemIcon>
              )}
              <ListItemText primary={text} />
            </StyledMenuItem>
          );
        })}
      </Menu>
    </div>
  );
};
